module.exports = __webpack_public_path__ + "img/auto-2.58d88e34.png";